/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsIcon, CmsIconSchema } from './icon'
import { type Image, ImageSchema } from './image'

/* TypeScript */
export type ListItemApiProps = {
  technicalName?: Maybe<string>
  icon?: Maybe<CmsIcon>
  image?: Maybe<Image>
  text?: Maybe<string>
}

/* Schemas */
export const ListItemSchema = z.object({
  technicalName: z.nullish(z.string()),
  icon: z.nullish(CmsIconSchema),
  image: z.nullish(ImageSchema),
  text: z.nullish(z.string()),
})

/* Schemas validation */
type TestListItem = ExpectTrue<
  Equal<ListItemApiProps, z.infer<typeof ListItemSchema>>
>
